import {
  CHANGE_SIDEBAR_VISIBILITY,
  CHANGE_MOBILE_SIDEBAR_VISIBILITY,
} from '../actions/sidebarActions';
import { getLocalStorage, setLocalStorage } from '../../shared/storage';

const collapseState = (getLocalStorage('sidebarCollapse') || 'false') === 'true';

const initialState = {
  show: false,
  collapse: collapseState,
};

export default function sidebar(state = initialState, action) {
  switch (action.type) {
    case CHANGE_SIDEBAR_VISIBILITY:
      setLocalStorage('sidebarCollapse', !state.collapse);
      return { ...state, collapse: !state.collapse };
    case CHANGE_MOBILE_SIDEBAR_VISIBILITY:
      return { ...state, show: !state.show };
    default:
      return state;
  }
}
